export const KEY_NAV_OPENED = 'is-nav-opened';



// WEBPACK FOOTER //
// src/common/utils/consts.js